import { addEffect, Canvas } from "@react-three/fiber";
import React from "react";
import { useEffect, useRef } from "react";
import { ACESFilmicToneMapping, PCFSoftShadowMap, sRGBEncoding } from "three";
import { CanvasContentComponent } from "./CanvasContentComponent";
import {
  TouchInteractions,
  useTouchInteractions,
} from "./hooks/useTouchInteractions";
import { useStore } from "./store/Store";

export type BloomProps = {
  enabled: boolean;
  strenght: number;
  threshold: number;
  radius: number;
  exposure: number;
};

export type FxProps = {
  realtimeReflections?: boolean;
  bloom?: BloomProps;
};

export type TrackingSettings8thWall =
  | "only-surface"
  | "only-image"
  | "image-surface"
  | "only-face";

type Props = {
  models: JSX.Element[];
  engine: "8thwall" | "gyro" | "none";
  tracking: TrackingSettings8thWall;
  imageTargets?: Array<string> | null;
  tapToPlace?: boolean;
  touchInteractions?: TouchInteractions;
  physics?: boolean;
  fxProps?: FxProps;
  renderLoopCb?: () => void;
  setCanvasMounted?: any;
};

export const CanvasComponent = ({
  models,
  engine,
  tracking,
  tapToPlace,
  imageTargets,
  touchInteractions,
  physics,
  fxProps,
  renderLoopCb,
  setCanvasMounted,
}: Props) => {
  const addAsset = useStore((store) => store.addAsset);

  const setTapToPlace = useStore.getState().setTapToPlace;
  useEffect(() => {
    setTapToPlace(!!tapToPlace);
  }, [setTapToPlace, tapToPlace]);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useTouchInteractions(canvasRef, touchInteractions);

  useEffect(() => {
    setCanvasMounted(true);
  }, [setCanvasMounted]);

  if (!imageTargets) {
    imageTargets = [];
  }

  addEffect(() => {
    renderLoopCb && renderLoopCb();
  });

  return (
    <>
      <Canvas
        ref={canvasRef}
        style={{
          height: "100vh",
          width: "100vw",
          position: "absolute",
          pointerEvents: "inherit",
          touchAction: "none",
        }}
        id="canvasAR"
        shadows
        linear
        gl={{
          preserveDrawingBuffer: true,
          antialias: true,
          alpha: true,
          physicallyCorrectLights: true,
          toneMapping: ACESFilmicToneMapping,
          outputEncoding: sRGBEncoding, // Only used in 3D setup. During 8thWall tracking we use EffectComposer which turns off outputEncoding
          pixelRatio: window.devicePixelRatio,
        }}
        onCreated={({ camera, gl, scene }) => {
          addAsset(scene, "scene");
          addAsset(camera, "camera");
          gl.shadowMap.enabled = true;
          gl.shadowMap.type = PCFSoftShadowMap;

          console.log(
            "canvas",
            gl.domElement,
            window.innerHeight,
            window.innerWidth
          );

          scene.add(camera);
        }}
        onPointerMissed={(_evt) => {
          console.log("missed", _evt);
        }}
      >
        <CanvasContentComponent
          models={models}
          engine={engine}
          tracking={tracking}
          imageTargets={imageTargets}
          physics={physics}
          fxProps={fxProps}
        />
      </Canvas>
    </>
  );
};
